export default function ObjectIsEmpty(obj) {
    for(const prop in obj) {
        if(Object.hasOwn(obj, prop)) {
            return false;
        }
    }
    
    return true;
}